<template>
  <div class="sui-datatable">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" md="7">
            <v-text-field
              v-model="options.search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            ></v-text-field
          ></v-col>
          &nbsp; &nbsp;

          <v-col cols="12" md="3">
            <v-select
              v-if="dropdownFilter"
              v-model="selectedLocation"
              @change="changeDropdown"
              :items="locations"
              item-text="name"
              item-value="id"
              :label="$t('location')"
              persistent-hint
              return-object
              single-line
            >
            </v-select>
          </v-col>
          &nbsp; &nbsp;

          <v-col cols="12" md="1">
            <v-btn
              v-if="create"
              color="red"
              @click.prevent="$emit('clickCreate')"
              >{{ $t("create") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-title>
      <div>
        <v-data-table
          class="elevation-1 sui-datatable-body"
          :loading="loading"
          :loading-text="$t('loading')"
          :headers="headers"
          :items="outItems"
          :page.sync="page"
          @click:row="clickRow"
          :hideDefaultFooter="true"
          :options.sync="dataOptions"
          :itemsPerPage="options.limit"
          :server-items-length="total"
          :noDataText="$t('noData')"
          :noResultsText="$t('noData')"
          @page-count="pageCount = $event"
          @update:sort-by="updateSort"
          @update:sort-desc="updateSortDesc"
          :footer-props="{
            showFirstLastPage: long,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-arrow-left',
            nextIcon: 'mdi-arrow-right',
            itemsPerPageOptions: [5, 10, 20, 50, 100, 500, 1000],
            itemsPerPageText: $t('itemsPerPage') + ' ',
            showCurrentPage: true,
          }"
        >
          <!-- <template v-slot:item="item">
			 <tr v-for="(i, index) in Object.assign({}, item.item)" :key="index">
				<div v-if="isHeader(index)" v-html="i">{{i}}</div>
			 </tr>
			</template> -->
          <template v-slot:item.is_active="{ item }">
            <v-icon v-if="item.is_active">mdi-check</v-icon>
            <v-icon v-else>mdi-cancel</v-icon>
          </template>
          <template v-slot:item.is_editable="{ item }">
            <v-icon v-if="item.is_editable">mdi-check</v-icon>
            <v-icon v-else>mdi-cancel</v-icon>
          </template>
          <template v-slot:item.image="{ item }">
            <img class="small-img" :src="item.image">
          </template>
          <template v-slot:item.color="{ item }">
            <v-chip :color="item.color != null ? item.color : '#e0e0e0'">{{item.color != null ? item.color : "#e0e0e0"}}</v-chip>
          </template>
          <template v-slot:item.groups="{ item }">
            {{displayGroups(item.groups)}}
          </template>
          
          <template v-slot:[`item.contracts_list`]="{ item }">
            <!-- <template v-slot:item="contracts_list"> -->
            <tr>
              <td v-html="item.contracts_list"></td>
            </tr>
          </template> 
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="!undeditable"
              icon
              @click.prevent="$emit('clickEdit', item)"
              color="orange"
              :disabled="item.is_editable == false"
              :class="item.is_editable == false ? 'noCursor' : ''"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn
              v-if="!undedeleteable"
              icon
              @click.prevent="$emit('clickRemove', item)"
              color="red"
              ><v-icon>mdi-trash-can</v-icon></v-btn
            >
          </template>
        </v-data-table>
        <div class="text-right pt-2">
          <div style="min-width: 5rem !important; margin: 13px !important">
            {{ $t("itemsPerPage") }}:
            <sui-dropdown
              style="min-width: 5rem"
              :options="limits"
              selection
              v-bind:value="options.limit"
              v-on:input="changeLimit"
            />
            <v-icon :disabled="options.start <= 1" @click.prevent="clickPrev"
              >mdi-arrow-left</v-icon
            >
            {{ options.start + 1 > total ? total : options.start + 1 }} -
            {{
              options.start + 1 + (options.limit - 1) > total
                ? total
                : options.start + 1 + (options.limit - 1)
            }}
            {{ $t("of") }}
            {{ total }}
            <v-icon
              :disabled="options.start + 1 + options.limit - 1 > total"
              @click.prevent="clickNext"
              >mdi-arrow-right</v-icon
            >
          </div>
          <br />
        </div>
      </div>
    </v-card>
	    <v-overlay :value="loading"
		:absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>
 <script>
import ApiService from "@/services/ApiService.js";
import DateService from "@/services/DateService.js";
import axios from "axios";
// import Limiter from "@/components/DataList/Segments/Limiter.vue";
// import Search from "@/components/DataList/Segments/Search.vue";
// import Pagination from "@/components/DataList/Segments/Pagination.vue";
export default {
  name: "DataList",
  components: {
    // Limiter,
    // Search,
    // Pagination,
  },
  props: {
    uri: {
      type: String,
      required: true,
    },
    deleteable: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    long: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    showBtn: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    undeditable: {
      type: Boolean,
      default: false,
    },
    undedeleteable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      outItems: [],
      // limit: 10,
      page: 1,
      pageCount: 1,
      itemsPerPage: 10,
      total: 0,
      loading: false,
      fallbackSort: "",
      dataOptions: {},
      limits: [
        { key: 10, value: 10, text: "10" },
        { key: 15, value: 15, text: "15" },
        { key: 30, value: 30, text: "30" },
        { key: 50, value: 50, text: "50" },
        { key: 100, value: 100, text: "100" },
        { key: 100, value: 100, text: "200" },
        { key: 500, value: 500, text: "500" },
        { key: 1000, value: 1000, text: "1000" },
      ],
      dropdownValue: 10,
      end: 0,
      storeUri: "",
    };
  },
  async created() {
    this.storeUri = this.uri;

    let tempoptions = "";
    localStorage.getItem(this.storeUri) != null ? (tempoptions = JSON.parse(localStorage.getItem(this.storeUri))) : "";
    console.log(tempoptions)
    if (tempoptions != null && tempoptions != "") {
      tempoptions.columns = this.options.columns;
      this.options = tempoptions;
    }
    this.headers = this.options.columns;

    // localStorage.getItem("debug") != null ? this.options = JSON.parse(localStorage.getItem("debug")) : ""
    // console.log(localStorage.getItem(this.options))

    this.render();
  },
  methods: {
    displayGroups(groups){
      let out = ""
      console.log(groups)
      for(let [,value] of Object.entries(groups)){
        out != "" ? out += ", " : ""
        out += value
			}
      return out
    },
    async render() {
      this.loading = true;
      this.long = false;
      let string = "";
      for (var i = 0; i < Object.keys(this.options).length; i++) {
        if (
          this.options[Object.keys(this.options)[i]] != undefined &&
          Object.keys(this.options)[i] != "columns" &&
          Object.keys(this.options)[i] != "onError" &&
          Object.keys(this.options)[i] != "group"
        ) {
          string != "" ? (string = string + "&") : "";
          string =
            string +
            Object.keys(this.options)[i] +
            "=" +
            this.options[Object.keys(this.options)[i]];
        }
      }
      if (string != "") {
        string = "?" + string;
      }
      this.uri.startsWith("http")
        ? ""
        : (this.uri = ApiService.getApiUrl() + this.uri);
      let resp = await axios.get(this.uri + string);
      if (resp.status >= 200 && resp.status <= 299) {
        resp.data.data == null
          ? (this.items = resp.data)
          : (this.items = resp.data.data);
        this.total = resp.data.total;
        this.total == null ? (this.total = this.items.length) : "";

        // this.items.forEach((element) => {
        //   this.getItemValue(element);
        // });

        for (i = 0; i < this.items.length; i++) {
          let el = this.items[i];
          let newObj = [];

          for (var [index, item] of Object.entries(el)) {
            if (index != "contracts_list" && !(typeof item == "object")) {
              item != 0 ? (item = this.$t(item) + "") : "";
              index == "price"
                ? (item = new Intl.NumberFormat("de-DE", {
                    style: "currency",
                    currency: "EUR",
                  }).format(item))
                : "";
              index == "tax" ? (item += " %") : "";
            }
            newObj[index] = item;
          }

          this.items[i] = newObj;
        }

        this.fallbackSort == ""
          ? (this.fallbackSort = this.options.sortKey)
          : "";
        this.dataOptions = this.options;
        this.outItems = this.items;
      } else {
        this.items = resp.data.error;
        this.loading = false;
      }
      // localStorage.setItem("debug", JSON.stringify(this.options))
      this.updateHeaders();
      this.loading = false;
      localStorage.setItem(this.storeUri, JSON.stringify(this.options));
    },
    updateSort(e) {
      e == ""
        ? (this.options.sortKey = this.fallbackSort)
        : (this.options.sortKey = e);
      this.render();
    },
    updateSortDesc(e) {
      e[0] == true
        ? (this.options.sortOrder = "DESC")
        : (this.options.sortOrder = "ASC");
      this.render();
    },
    log(e) {
      console.log(e);
    },
    updateHeaders() {
      // let tempoptions = "";
      // localStorage.getItem(this.storeUri) != null
      //   ? (tempoptions = JSON.parse(localStorage.getItem(this.storeUri)))
      //   : "";
      // if (tempoptions != null) {
      //   tempoptions.columns = this.options.columns;
      //   this.options = tempoptions;
      // }
      this.headers = this.options.columns;

      this.headers.forEach((el) => {
        // el.text == null && el.label != null ? (el.text = el.label) : "";
        el.value == null && el.name != null ? (el.value = el.name) : "";
        if (el.translate != false) {
          el.text = this.$t(el.label);
        } else {
          el.text = el.label;
        }
      });

      this.headers.forEach((el) => {
        this.headerVal(el);
      });
    },
    clickRow(e) {
      this.$emit("clickRow", e);
    },
    clickPrev() {
      this.options.start = this.options.start - this.options.limit;
      this.options.start < 0 || this.options.start == null
        ? (this.options.start = 0)
        : "";
      this.render();
    },
    clickNext() {
      this.options.start + this.options.limit > this.total
        ? ""
        : (this.options.start = this.options.start + this.options.limit);
      // this.options.start < 0 || this.options.start == null ? this.options.start = 0 : ""
      this.render();
    },
    clickChangePagination(e) {
      this.options.start = e;
      this.render();
    },
    changeSearch(e) {
      this.options.search = e;
      this.render();
    },
    changeLimit(e) {
      this.options.limit = e;
      this.render();
    },
    async headerVal(val) {
      if (val.timestamp) {
        this.items.forEach((el) => {
          el.timestamp =
            this.$t("from") +
            " " +
            DateService.toHumanDate(el.start_time) +
            " " +
            this.$t("to") +
            " " +
            DateService.toHumanDate(el.end_time);
        });
      }
      if (val.time) {
        this.items.forEach((el) => {
          el[val.value] != null
            ? (el[val.value] = DateService.toHumanDate(el[val.value]))
            : "";
        });
      }
      if (val.name == "contracts_list") {
        this.items.forEach((el) => {
          let out = "";
          el.contracts.forEach((con) => {
            let shortname = "<b>" + con.name + "</b><br>";
            if (con.name.length > 20) {
              shortname =
                "<b title='" +
                con.name +
                "'>" +
                con.name.substring(0, 20) +
                "... </b><br>";
            }
            out += shortname;
          });
          el.contracts_list = out;
        });
      }
      if(val.translate){
        this.items.forEach((el) => {
          el[val.value] != null
            ? (el[val.value] = this.$t(el[val.value]))
            : "";
        });
      }
      if(val.canzero){
        this.items.forEach((el) => {
          el[val.value] == null
            ? (el[val.value] = 0)
            : "";
        });
      }
      // if(val.color){
      //   this.items.forEach((el) => {
      //     el[val.value] == null
      //       ? (el[val.value] = "#e0e0e0777")
      //       : "";
      //   });
      // }
      val.name = this.$t(val.name);
    },
    async getItemValue(item) {
      Object.entries(item).forEach((el) => {
        let name = el[0];
        let value = el[1];

        if (name == "contracts_list") {
          value = null;
          let out = "";
          for (var i = 0; i < this.items[0].contracts.length; i++) {
            this.items[0].contracts[i];
            let shortname =
              "<b>" + this.items[0].contracts[i].name + "</b><br>";
            if (this.items[0].contracts[i].name.length > 20) {
              shortname =
                "<b title='" +
                this.items[0].contracts[i].name +
                "'>" +
                this.items[0].contracts[i].name.substring(0, 20) +
                "... </b>";
            }
            out += shortname;
          }
          value = out;
        }
        item.contracts_list = value;
      });
    },
  },
  watch: {
    "options.search": function () {
      this.changeSearch(this.options.search);
    },
    "$i18n.locale": function () {
      this.updateHeaders();
    },
  },
};
</script>

<style lang="scss">
.v-pagination__item--active {
  background: rgb(71, 71, 219) !important;
  color: black !important;
}
.small-img {
  max-width: 7rem;
  max-height: 7rem;
}
@import "@/assets/scss/datatable.scss";
</style>